import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
//weboffice local locales
import enLocales from './en.json';
import dkLocales from './dk.json';
import noLocales from './no.json';
import svLocales from './sv.json';
//gsg shared/external locales
import {
  enGsgUiTranslations as enExternal,
  dkGsgUiTranslations as dkExternal,
  noGsgUiTranslations as noExternal,
  svGsgUiTranslations as svnExternal
} from '@gsgroup/gsgroup-react-ui';

const merge = (app: object, lib: object) => ({ ...lib, ...app });

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: merge(enLocales, enExternal) },
      dk: { translations: merge(dkLocales, dkExternal) },
      no: { translations: merge(noLocales, noExternal) },
      sv: { translations: merge(svLocales, svnExternal) }
    },
    lng: localStorage.getItem('i18nextLng') || 'en',
    fallbackLng: 'en',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
